import React, { useEffect, useMemo, useRef } from "react";
import { Film, X } from "lucide-react";
import { API_BASE_URL } from "../../../../../../api";
import "../../../Apprenant/components/ContentRenderer.css";
import "./CapsuleVideoModal.css";

const buildAbsoluteMediaUrl = (value) => {
    if (!value) return null;
    return value.startsWith("http") ? value : `${API_BASE_URL}${value}`;
};

const buildAbsoluteVideoUrl = (capsule) => {
    if (!capsule) return null;
    if (capsule.videoUrl) return buildAbsoluteMediaUrl(capsule.videoUrl);
    if (capsule.video) return `${API_BASE_URL}/api/formations/capsules/videos/${capsule.video}`;
    return null;
};

export default function CapsuleVideoModal({ isOpen, onClose, capsule }) {
    const videoRef = useRef(null);
    const videoSrc = useMemo(() => buildAbsoluteVideoUrl(capsule), [capsule]);

    useEffect(() => {
        if (!isOpen && videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
    }, [isOpen]);

    useEffect(() => {
        const currentVideo = videoRef.current;
        return () => {
            if (currentVideo) {
                currentVideo.pause();
                currentVideo.currentTime = 0;
            }
        };
    }, []);

    if (!isOpen || !capsule) return null;

    const closeModal = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
        onClose?.();
    };

    return (
        <div className="capsule-video-modal-overlay" onMouseDown={(event) => event.target === event.currentTarget && closeModal()}>
            <div className="capsule-video-modal" onMouseDown={(event) => event.stopPropagation()}>
                <div className="capsule-video-modal__header">
                    <div className="capsule-video-modal__title-group">
                        <h3>{capsule.nom || "Capsule video"}</h3>
                        <span className="capsule-video-modal__reference">{capsule.reference || "-"}</span>
                    </div>
                    <button type="button" className="capsule-video-modal__close" onClick={closeModal} aria-label="Fermer">
                        <X size={18} />
                    </button>
                </div>

                <div className="capsule-video-modal__body">
                    <div className="capsule-video-modal__player-wrap">
                        {videoSrc ? (
                            <video
                                ref={videoRef}
                                className="cr-video capsule-video-modal__player"
                                controls
                                preload="metadata"
                                src={videoSrc}
                            >
                                Votre navigateur ne prend pas en charge cette video.
                            </video>
                        ) : (
                            <div className="capsule-video-modal__placeholder">
                                <Film size={42} />
                                <p>Video indisponible</p>
                            </div>
                        )}
                    </div>

                    <div className="capsule-video-modal__meta">
                        <span className="capsule-video-modal__chip"><strong>Domaine</strong>{capsule.domaineNom || "-"}</span>
                        <span className="capsule-video-modal__chip"><strong>Theme</strong>{capsule.themeNom || "-"}</span>
                        <span className="capsule-video-modal__chip"><strong>MOOC</strong>{capsule.ajouterAuMooc ? "Oui" : "Non"}</span>
                    </div>

                    <div className="capsule-video-modal__description">
                        <h4>Description</h4>
                        <p>{capsule.description || "Aucune description disponible."}</p>
                    </div>
                </div>

                <div className="capsule-video-modal__footer">
                    <button type="button" className="capsule-video-modal__btn" onClick={closeModal}>
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
}
